import React from "react";
import { ClipboardList, FileCheck, Sparkles } from "lucide-react";
import { howItWorks } from "../mock";
import { Button } from "./ui/button";

const icons = [ClipboardList, FileCheck, Sparkles];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="relative">
      <div className="bg-[#143527] rounded-[2.5rem] mx-4 lg:mx-10 py-20 lg:py-28 px-6 lg:px-14">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mb-16">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#e8a428] mb-4">
              How It Works
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#f4ebde]">
              From first call to spotless space — in three steps.
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
            {howItWorks.map((step, i) => {
              const Icon = icons[i];
              return (
                <div key={step.step} className="relative">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-full bg-[#e8a428] flex items-center justify-center">
                      <Icon className="w-6 h-6 text-[#143527]" strokeWidth={1.6} />
                    </div>
                    <span className="font-serif text-5xl text-[#e8a428]/40">{step.step}</span>
                  </div>
                  <h3 className="font-serif text-2xl lg:text-3xl text-[#f4ebde] mb-3">
                    {step.title}
                  </h3>
                  <p className="text-[14px] text-[#f4ebde]/70 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="flex justify-center mt-16">
            <Button
              className="rounded-full px-8 py-6 btn-cream text-[15px]"
              onClick={() => {
                const el = document.getElementById("quote");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Start your quote →
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
